// extracted by mini-css-extract-plugin
export default {"container":"home_container__6gMmI","main":"home_main__7V+Ky"};